import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
    name: "supportMessage",
})
export class SupportMessagePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, color: string = "#4252cc"): SafeHtml {
        if (!text) return text;

        const urlRegex = /(https?:\/\/[^\s]+)/g;

        const replacedText = text.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" 
                style="color:${color}; font-weight:500; text-decoration:underline;">
                ${url}
              </a>`;
        });

        return this.sanitizer.bypassSecurityTrustHtml(replacedText);
    }
}
